import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import { SiteContext } from "../layouts/Main";
import Container from "./Container";
import Menu from "./Menu";
import Search from "./Search";
import FormModal from "./FormModal";
import logo from "../images/logo.png";
import main_menu from "../data/main-menu.json";
import { logoutServer } from "../util/http";
import { useAuth } from "./auth-context";

function SiteHeader() {
  const {userState, logoutUser} = useAuth();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [searchOpen, setSearchOpen] = React.useState(false);
  const siteContext = React.useContext(SiteContext);
  React.useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOpen]);

  React.useEffect(() => {
    if (searchOpen) {
      document.body.classList.add("search-open");
    } else {
      document.body.classList.remove("search-open");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchOpen]);
const handleLogout = () => {

  logoutServer()
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      logoutUser();
    });
};
  return (
    <StaticQuery
      query={graphql`
        query SearchIndexQuery {
          siteSearchIndex {
            index
          }
        }
      `}
      render={(data) => (
        <header id="site-header">
          <Container>
            <div className="l">
              <button
                id="burger"
                className="button"
                title="Toggle Menu"
                onClick={(e) => setMenuOpen(!menuOpen)}
              >
                <b />
                <b />
                <b />
              </button>
              <button id="menu-underlay" onClick={(e) => setMenuOpen(false)}>
                <span>Close menu</span>
              </button>
              <Link
                to="/"
                title="Go to home page"
                className="logo"
                onClick={(e) => setMenuOpen(false)}
              >
                <img src={logo} alt={siteContext.site.siteMetadata.title} />
              </Link>
              <Menu {...main_menu} setMenuOpen={setMenuOpen} />
            </div>
            <div className="r">
              {userState?.token ? (
                <button
                  className="button outline"
                  onClick={handleLogout}
                >
                  {"Sign out"}
                </button>
              ) : (
                <Link
                  to="/login"
                  className="button outline"
                  onClick={(e) => {
                    setMenuOpen(false);
                  }}
                >
                  Sign in
                </Link>
              )}
              <FormModal
                buttonLabel="Request Demo"
                buttonType="solid"
                height="570"
                type="demo"
              />
              <button
                title="Search"
                className="button link"
                onClick={(e) => {
                  setMenuOpen(false);
                  setSearchOpen(true);
                }}
              >
                <i className="icon-search"></i>
              </button>
              {searchOpen && (
                <Search
                  searchIndex={data.siteSearchIndex.index}
                  setSearchOpen={setSearchOpen}
                />
              )}
            </div>
          </Container>
        </header>
      )}
    />
  );
}

export default SiteHeader;
